import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getInsuranceMapListById, saveInsuranceMapData, updateInsuranceMapData } from "../../redux/actions/InsuranceMapActions";
import FormInput from "../../Components/FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getMasterInsuranceList,  getMasterAllUserList} from "../../redux/actions/MasterActions";
import Preloader from "../../Components/Preloader";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddInsuranceMap = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    insuranceMapReducer: {
      loadingInsuranceMap,
      errorsInsuranceMap,
      insuranceMapLists,
      changedInsuranceMapStatus,
    },
    masterReducer: {
      masterInsuranceList,
      loadingMaster,
      errorsMaster,
      masterStateLists,
      masterUserLists,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if ( show && auth?.token) {
      dispatch(getMasterInsuranceList(auth.token));
      dispatch(getMasterAllUserList(auth.token));
    }
  }, [show, auth?.token, dispatch]);

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(getInsuranceMapListById(auth?.token, editId));
    }
  }, [auth, editId]);

  
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if(editId)
    {
      dispatch(updateInsuranceMapData(auth?.token, formData,editId));
    }
    else
    {
      dispatch(saveInsuranceMapData(auth?.token, formData));
    }
  };

  useEffect(()=>{
    if(editId && insuranceMapLists && Object.keys(insuranceMapLists).length > 0) {
      setFormData({
        insuranceCompanies: JSON.parse(insuranceMapLists?.insuranceCompanies),
        userId: insuranceMapLists?.userId ,
      });
    }
  },[insuranceMapLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide(); // Close modal on logout
    }
  }, [errors, dispatch, onHide]);

  useEffect(() => {
    if (errorsMaster && Object.keys(errorsMaster).length > 0) {
      if(errorsMaster?.status==401){
        dispatch(logout())
        toast.error(errors?.data?.message);
        onHide();
      }
    }
  }, [errorsMaster]);

  useEffect(() => {
    if (changedInsuranceMapStatus?.success) {
    onHide()
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedInsuranceMapStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      setFormData({});
      dispatch({ type: 'RESET_DELETE_INSURANCE_MAPPING_STATUS' });
    }
  }, [changedInsuranceMapStatus, dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
  };

  const selectHandler = (selectedData, name) => {
    console.log(selectedData);
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0]?.id
    }));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      }
    }),
  };


  return (
    <Modal show={show} onHide={onHide} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && insuranceMapLists && Object.keys(insuranceMapLists).length > 0) ? t("Update InsuranceMap") : t("Add InsuranceMap")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
            {errorsInsuranceMap?.data?.message && (
              <div className="alert alert-danger">
                {errorsInsuranceMap?.data?.message}
              </div>
            )}
          <Row>
            <Col lg={12}>
              <Form.Group className="mb-3">
                <Form.Label>{t("User")} <span style={{color:'red',fontSize:15}}>*</span></Form.Label>
                <Select
                  options={masterUserLists}
                  values={masterUserLists?.filter((user) => user?.id === formData?.userId)}
                  name="userId"
                  labelField={"name"}
                  valueField={"id"}
                  loading={loadingMaster}
                  searchBy="name"
                  onChange={(selectedData) => selectHandler(selectedData, "userId")}
                  styles={customSelectStyles}
                />
                
                {errorsInsuranceMap?.data?.userId && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{errorsInsuranceMap?.data?.userId}</p>
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col lg={12}>
            <Form.Group className="mb-3">
                <Form.Label>{t("Insurance Companies")} <span style={{color:'red',fontSize:15}}>*</span></Form.Label>
                <Select
                  options={masterInsuranceList}
                  values={masterInsuranceList?.filter((insurance) =>formData?.insuranceCompanies?.includes(insurance?.id))}
                  name="insuranceCompanies"
                  labelField={"name"}
                  valueField={"id"}
                  loading={loadingMaster}
                  multi={true}
                  searchBy="name"
                  onChange={(selectedData) => {
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        insuranceCompanies: JSON.stringify(selectedData?.map(insurance => insurance?.id))
                      }));
                  }}
                  styles={customSelectStyles}
                />
                
                {errorsInsuranceMap?.data?.insuranceCompanies && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{errorsInsuranceMap?.data?.insuranceCompanies}</p>
                  </div>
                )}
              </Form.Group>
            </Col>

            {/* <Col lg={12}>
              <FormInput
                label={t("InsuranceMap Name")}
                type="text"
                errors={errorsInsuranceMap?.data}
                value={formData.insuranceMap_name}
                name="insuranceMap_name"
                required={true}
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
            </Col> */}
          </Row>
          <div className="d-flex justify-content-center">
            {loading ? 
              <Button color="primary" disabled>
                <Spinner animation="border" size="sm" />
                {t("Please wait ...")}
              </Button>
            :
              <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {(editId && insuranceMapLists && Object.keys(insuranceMapLists).length > 0) ? t("Update") : t("Add")}
              </Button>
            }
          </div>
        
      </Modal.Body>
      {loadingInsuranceMap && <Preloader />}
    </Modal>
  );
};

export default AddInsuranceMap;
